import * as React from "react";
import PropTypes from "prop-types";
import { Icon } from "@lululemon/ui-library";
import { circleCheckmarkIcon } from "@lululemon/ui-icons";
import cs from "classnames";

import styles from "./bra-quiz-results.module.scss";

export const BraQuizResultBody = ({
  description,
  isEmbedded,
  pills,
  title
}) => (
  <>
    <div className={styles.braQuizResultsIconBox}>
      <Icon
        content={circleCheckmarkIcon}
        className={styles.circleCheckmarkIcon}
      />
    </div>

    <p className={styles.braQuizResultsTitle} id="bra-quiz-modal-title">
      {title}
    </p>
    <p className={styles.braQuizResultsDescription}>{description}</p>
    <div
      className={cs(styles.braQuizResultsPills, {
        "center-xs": !isEmbedded,
        [styles.braQuizResultsPillsEmbedded]: isEmbedded
      })}
    >
      {pills}
    </div>
  </>
);

BraQuizResultBody.propTypes = {
  description: PropTypes.string.isRequired,
  isEmbedded: PropTypes.bool,
  pills: PropTypes.arrayOf(PropTypes.element).isRequired,
  title: PropTypes.string.isRequired
};

BraQuizResultBody.defaultProps = {
  isEmbedded: false
};
